/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/report-signatory.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItemsAuditRecord,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const propArray = ['OrgKey', 'Module', 'InUse'];

const ReportSignatoryRecordChangeGridPBI = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
    };

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
    };

    const items = getFieldChangeItemsAuditRecord(refactoredOldRecord, refactoredNewRecord, null, (field: string) => {
        getProcessedFieldChangeItems({
            oldRecord,
            newRecord,
            oldItem,
            newItem,
            field,
        });
    });

    return <FieldChangeGrid items={items} />;
};

export { ReportSignatoryRecordChangeGridPBI };
